// extracted by mini-css-extract-plugin
export var statItem = "_la-1";
export var statsRow = "_la-0";